// RxJS

// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../../core/reducers';
// Selectors
import {
  selectQueryResult,
  selectRoleTemplatesPageLoading,
  selectRolesShowInitWaitingMessage,
} from '../_selectors/role-template.selectors';

export class RoleTemplatesDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectRoleTemplatesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectRolesShowInitWaitingMessage));

    this.store.pipe(select(selectQueryResult)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
